var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel-item',{attrs:{"field":_vm.field}},[_c('template',{slot:"value"},[(_vm.preview)?_c('v-lazy-image',{staticClass:"shadow-md rounded m-2 block",style:({
                width: 'auto',
                height: 'auto',
                maxWidth: ((_vm.field.defail_width) + "px"),
                maxHeight: ((_vm.field.defail_height) + "px")
            }),attrs:{"src":_vm.preview,"src-placeholder":_vm.$options.spinner}}):_vm._e()],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }